import { useParams } from "react-router-dom";
import GuideTemplate from "../templates/GuideTemplate";
import { SAMPLE_GUIDE, GUIDE_ROUTES } from "../data/guides";

function placeholderGuide(slug) {
  const meta = GUIDE_ROUTES.find((g) => g.slug === slug);
  const title = meta ? meta.title : slug.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return {
    slug,
    title,
    summary: `This guide is being prepared by our team. It will provide balanced, responsible information to help you understand your options before you travel.`,
    image: "https://images.unsplash.com/photo-1764084455648-521862e715e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    sections: [
      { h2: "Content in preparation", body: "We are finalising medically-reviewed content for this guide. In the meantime, you can request a private, no-obligation case review to receive guidance specific to your situation." },
      { h2: "How we help", body: "Plastic Surgery Vietnam coordinates information and communication so you can make an informed decision. All clinical decisions are made by licensed medical professionals." },
    ],
    relatedGuides: GUIDE_ROUTES.filter((g) => g.slug !== slug).slice(0, 3).map((g) => g.slug),
    isPlaceholder: true,
  };
}

export default function GuidePage() {
  const { slug } = useParams();
  const data = slug === SAMPLE_GUIDE.slug ? SAMPLE_GUIDE : placeholderGuide(slug);
  return <GuideTemplate data={data} />;
}
